export default "__VITE_ASSET__BVHsM8k7__"